// Запросы про пароль: состояние политики, смена и восстановление по почте.

import axios from 'axios';
import apiClient from 'shared/api/client';
import { API_ROUTES } from 'shared/constants/api';
import type { PasswordState } from './passwordState';

export type { PasswordState } from './passwordState';

export interface PasswordChangeResult {
  message: string;
  /** Сколько других входов погасили при смене. */
  sessions_revoked: number;
}

export interface PasswordRequirements {
  min_length: number;
  requirements: string[];
  /** Сколько неудачных попыток входа подряд закрывают вход. 0 — не блокировать. */
  login_max_attempts: number;
  /** На сколько минут закрывается вход. */
  login_lock_minutes: number;
}

/**
 * Требования к паролю без авторизации: их показывает страница смены забытого
 * пароля, на которую человек приходит по ссылке из письма.
 */
export async function fetchPasswordRequirements(): Promise<PasswordRequirements> {
  const { data } = await axios.get<PasswordRequirements>(API_ROUTES.auth.passwordRequirements);
  return data;
}

/**
 * Запросить ссылку на смену забытого пароля.
 *
 * Ответ одинаковый и для существующего адреса, и для неизвестного: иначе форма
 * стала бы проверялкой, кто в системе зарегистрирован.
 */
export async function requestPasswordReset(email: string): Promise<void> {
  await axios.post(API_ROUTES.auth.forgotPassword, { email });
}

/** Задать новый пароль по одноразовому токену из письма. */
export async function resetPassword(token: string, password: string): Promise<void> {
  await axios.post(API_ROUTES.auth.resetPassword, { token, password });
}

/** Состояние пароля текущего пользователя и требования к новому. */
export async function fetchPasswordState(): Promise<PasswordState> {
  const { data } = await apiClient.get<PasswordState>(API_ROUTES.auth.passwordState);
  return data;
}

/**
 * Сменить пароль. Отказы бэкенда: 400 — неверный текущий пароль или
 * расхождение подтверждения, 422 — пароль не прошёл политику или повторяет
 * прежние. Текст из detail показываем как есть.
 */
export async function changePassword(payload: {
  current_password: string;
  new_password: string;
  new_password_confirm: string;
}): Promise<PasswordChangeResult> {
  const { data } = await apiClient.post<PasswordChangeResult>(
    API_ROUTES.auth.passwordChange,
    payload,
  );
  return data;
}
